module.exports = __webpack_public_path__ + "static/media/grid-image3.39bb621b.jpg";